<template>
  <div class="gallery-background">
    <div class="close-gallery">close</div>
    <div class="photo-gallery">
      <div>
        <img src="img/gallery/photo1.jpg" alt="Restaurant menu display">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo2.jpg" alt="Telephone patch panel">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo3.jpg" alt="Cash register">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo4.jpg" alt="Cash register">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo5.jpg" alt="Credit card reader">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo6.jpg" alt="Network appliances">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo7.jpg" alt="Network appliances">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo8.jpg" alt="Electrical wiring">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo9.jpg" alt="Server appliance">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo10.jpg" alt="Touch display kiosk">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo11.jpg" alt="Server appliances">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo12.jpg" alt="VOIP Telephone">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo13.jpg" alt="Server room">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo14.jpg" alt="Fiber line installation">
        <p>This is a test caption.</p>
      </div>
      <div>
        <img src="img/gallery/photo15.jpg" alt="Uninterupted power supply">
        <p>This is a test caption.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  data() {
    return {};
  },
  mounted() {
    // eslint-disable-next-line
    $('.photo-gallery').slick({
      infinite: true,
    });

    // eslint-disable-next-line
    $('.gallery').click(() => {
      // eslint-disable-next-line
      $('.gallery-background').show();
      // eslint-disable-next-line
      $('.photo-gallery').slick('slickGoTo', 0);
    });

    // eslint-disable-next-line
    $('.close-gallery').click(() => {
      // eslint-disable-next-line
      $('.gallery-background').hide();
    });
  },
};
</script>

<style lang='scss' scoped></style>
